import { Stack } from '@mui/material';
import { useState } from 'react';
import ErrorBoundary from './error-page';
import Loader from '@shared/components/Loader';
import FilterButtons from '@shared/components/FilterButtons';
import { useFormatCurrency } from '@features/currency/currency.hooks';
import {
  mapStocksStockItemsToFlatStockItems,
  filterStockItemsByView,
  STOCK_ITEM_FILTER_BUTTONS_CONFIG,
  StockItemView,
  type StockItemViewKey,
} from '../features/stock/entity';
import { useStockItemsQuery } from '../features/stock/queries';
import { StockAiIntake } from '../features/stock/components/stock-ai-intake/stock-ai-intake';
import { StockItemRow } from '../features/stock/components/stock-item-row';

const Stock = () => {
  const { data: stocksWithStockItems, isError, isLoading } = useStockItemsQuery(undefined);
  const [activeView, setActiveView] = useState<StockItemViewKey>(StockItemView.all);
  const { format: formatAmount } = useFormatCurrency();

  const allItems = mapStocksStockItemsToFlatStockItems(stocksWithStockItems);
  const stockItems = allItems ? filterStockItemsByView(allItems, activeView) : undefined;

  if (isLoading) {
    return <Loader />;
  }

  if (isError || !stockItems) {
    return <ErrorBoundary />;
  }

  return (
    <Stack spacing={2} sx={{ height: '100%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <FilterButtons
          activeFilter={activeView}
          filterButtonsConfig={STOCK_ITEM_FILTER_BUTTONS_CONFIG}
          onChange={setActiveView}
        />
        <StockAiIntake />
      </Stack>
      <Stack>
        {stockItems.map(item => (
          <StockItemRow key={item.id} item={item} formatAmount={amount => formatAmount(amount)} />
        ))}
      </Stack>
    </Stack>
  );
};

export default Stock;
